import React from 'react';
import _ from 'lodash';
import plotly from 'plotly.js';
import plotComponentFactory from 'react-plotly.js/factory';
import { compile } from 'mathjs';

const Plot = plotComponentFactory(plotly);


class PlotNewton extends React.Component {


    render() {

        if (this.props.datos.solution.length > 0) {

            const estado = this.props.datos.form.values;

            const x_array = _.range(_.toNumber(estado.rango_a), _.toNumber(estado.rango_b), 0.5);
            const y_func = compile(_.toLower(estado.funcion));

            const y_array = [];

            for (var i = 0; i < x_array.length; i++) {
                y_array.push(y_func.evaluate({ x: x_array[i] }))
            };

            const resultados_y = [];

            for (var k = 0; k < this.props.datos.solution.length; k++) {
                resultados_y.push(y_func.evaluate({ x: this.props.datos.solution[k] }))
            };

            return (
                <Plot
                    data={[
                        { type: 'lines', x: x_array, y: y_array, name: 'f(x)' },
                        { type: 'scatter', mode: 'markers', x: this.props.datos.solution, y: resultados_y, name: 'Solucion' }
                    ]}
                    layout={{ autosize: true, staticPlot: true, xaxis: { title: 'x' }, yaxis: { title: 'f(x)' } }}
                />

            )
        }
        else {
            return (<div></div>)
        }

    }
}

export default PlotNewton;